import { useNavigate, useParams } from 'react-router-dom';

export enum UserDetailsTabs {
  MyDetails = 'details',
  Password = 'password',
}

export function useUserDetailsTabs() {
  const navigate = useNavigate();
  const { tab } = useParams<{ tab: UserDetailsTabs }>();

  const setTab = (value: UserDetailsTabs) => {
    navigate(`/user/${value}`);
  };

  return {
    currentTab: tab,
    setTab,
  };
}
